export var isSSR = function isSSR() {
  var _SERVER__;
  return (_SERVER__ = globalThis.__SERVER__) !== null && _SERVER__ !== void 0 ? _SERVER__ : false;
};
export var getAggSubscriptionEndpoint = function getAggSubscriptionEndpoint() {
  return "".concat(window.location.origin.replace('http', 'ws'), "/gateway/api/graphql/subscriptions");
};